<template>
  <div class="companySettings">
    <section id="leftPane">

      <h1>{{dynamicTitle('editCompanyInfo')}}</h1>
      <p class="warningMessage" v-if="isWarning">!未入力の項目があります!</p>

      <div id="companyNameInputArea">
        <h2 class="inputTitle" >{{dynamicTitle('companyName')}}</h2>
        <input :class="{warned: (isWarning && !companyName)}" type="text" placeholder="店名" v-model="companyName">
      </div>

      <div>
        <button class="button" :class="{disabled: isButtonDisabled}" @click="editCompanyInfo">変更する</button>
      </div>

    </section>

    <div class="loadingBackground" v-if="isLoading">
      <div class="loadingDialog">
        <half-circle-spinner
          :animation-duration="1000"
          :size="60"
          :color="'#ffffff'"
        />
      </div>
    </div>

  </div>

</template>


<script >
  import {auth, db, fb} from '../firebase'
  import {HalfCircleSpinner} from 'epic-spinners'

  const words = {
    'dayservice' : {
      'editCompanyInfo' : '施設情報編集',
      'companyName' : '施設名'
    },
    'bike' : {
      'editCompanyInfo' : 'お店情報編集',
      'companyName' : '店名'
    },
    'default' : {
      'editCompanyInfo' : '企業情報編集',
      'companyName' : '企業名'
    }
  }

  export default {
    name: 'CompanySettings',

    components: {
      HalfCircleSpinner
    },

    data () {
      return {
        originalCompanyName: '',
        companyName: '',

        isLoading: false,

        /* 入力にエラーがあるかどうかのフラグ */
        isWarning: false,

        company: null
      }
    },

    computed: {
      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },

      isButtonDisabled() {
        if(this.companyName && this.companyName.length > 0 && this.originalCompanyName !== this.companyName) {
          return false
        }else{
          return true
        }
      }
    },

    methods: {
      editCompanyInfo: function () {

        if(this.isButtonDisabled){
          console.log("button is disabled")

          /* 未入力チェック */
          if(!this.companyName){
            this.isWarning = true
          }
          return
        }


        this.isWarning = false

        if(this.companyName == null){
          //TODO: エラーを表示してリターン
          console.log("companyName is Null")
          return
        }
        /* カンパニー名の更新 */
        if(this.companyName !== this.originalCompanyName) {
          //this.updateCompany(this.companyName)
          this.doUpdateCompany(this.companyName)
        }


      },

      updateCompany(companyName) {
        db.collection('companies').doc(this.companyId).update({name: companyName}).then(function (){
            console.log("companyName updated")
        })
      },

      async doUpdateCompany(companyName){
        this.isLoading = true
        try{
          let promise = db.collection('companies').doc(this.companyId).update({name: companyName})

          let result = await promise

          console.log("companyName updated")
          this.originalCompanyName = companyName
          this.isLoading = false

          await new Promise((resolve, reject) => {
            setTimeout(() => resolve(true), 500) // resolve
          })
          this.$router.replace({ name: 'Home'})
        }catch(error){
          console.log('Error updating the company:', error);
          this.isLoading = false
        }
      },

      getCompany () {
        let self = this

        this.$bind('company', db.collection('companies').doc(this.companyId)).then(company => {
          this.$unbind('company')
        })
      },


      /* ダイナミックタイトル */
      dynamicTitle(key){
        if(this.company){
          let type = this.company.type
          let wordSet = words[type]
          if(!wordSet){
            wordSet = words['default']
          }
          return wordSet[key]
        }
        return words['default'][key]
      }


    },



    mounted() {
      db.collection('companies').doc(this.companyId).get().then((doc) => {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          this.companyName = doc.data().name
          this.originalCompanyName = this.companyName
        }
      })

      let user = auth.currentUser;
      if(user != null){
        this.email = user.email
        this.originalEmail = this.email
      }

      /*
      auth.onAuthStateChanged(function (user) {
        if (user) {
          this.email = user.email
          this.originalEmail = this.email
          console.log("email set", this.email)

        }
      })*/

      if(!this.companyId){
        this.$router.push('/signin')
      }else{
        this.getCompany()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>




  #leftPane {
    text-align: left;
    margin-left: 7%;
  }

  #leftPane h1{
    color: #5C5C5C;
    font-size: 33px;
    font-weight: normal;
    margin-top: 40px;
  }


  h2 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  input {
    width: 300px;
    height: 35px;
    margin-top: 0;
  }

  #companyNameInputArea {
    margin-top: 22px;
  }

  .inputTitle {
    color: #5C5C5C;
    font-size: 20px;
    font-weight: lighter;
    margin-top: 2px;

  }


  button.disabled {
    background-color: #D2D2D2;
  }

  button.disabled:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
  }

  /* 未入力の項目の警告用スタイル */
  .warned {
    background-color: #F3C99F;
  }

  .warningMessage {
    color: #FF6B49;
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 0;
  }

  input {
    width: 340px;
    height: 28px;
    padding: 10px;
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
    box-shadow: 0 0 0 #D2D2D2;
  }

  input:focus {
    outline: none !important;
    border:2px solid #D2FF00;
    box-shadow: 0 0 0 #D2FF00;
  }


  @media(max-width: 400px){

    #leftPane {
      text-align: center;
      margin: 0 auto 0 auto;
    }

    #leftPane h1{
      text-align: left;
      color: #5C5C5C;
      font-size: 21px;
      font-weight: bold;
      margin-top: 39px;
      margin-left: 25px;
    }

    /* 未入力の項目の警告用スタイル */
    .warned {
      background-color: #F3C99F;
    }

    .warningMessage {
      color: #FF6B49;
      font-size: 15px;
      margin-top: 0;
      margin-bottom: 0;
    }

    .inputTitle {
      text-align: left;
      color: #5C5C5C;
      font-size: 15px;
      font-weight: lighter;
      margin-top: 2px;
      margin-left: 25px;
      margin-bottom: 0;
    }

    input {
      width: 86%;
      margin: 0 auto 0 auto;
      height: 28px;
      padding: 10px;
      border-style: solid;
      border-width: 1px;
      border-color: #D2D2D2;
      box-shadow: 0 0 0 #D2D2D2;
    }

    input:focus {
      outline: none !important;
      border:2px solid #D2FF00;
      box-shadow: 0 0 0 #D2FF00;
    }

    #mailInputArea input {
      width: 86%;
    }

    .button {
      text-align: center;
      margin-top: 20px;
      margin-bottom: 25px;
      padding: 7px 10px 7px 10px;
      font-weight: bold;
      font-size: 15px;
    }
  }



</style>



// WEBPACK FOOTER //
// src/pages/CompanySettings.vue